import { render, staticRenderFns } from "./confirmation-form.vue?vue&type=template&id=dfee198c"
import script from "./confirmation-form.vue?vue&type=script&lang=js"
export * from "./confirmation-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports